import React from 'react';
import { Navigate } from 'react-router';
import { useDebriefRouter } from 'ff/debrief/hooks';
import * as API from 'ff/debrief/features/TracklogApi';

const RedirectToShared = () => {
    const { getSharedRouteString } = useDebriefRouter();
    const sharedTracklogsQuery = API.useGetAllSharedTracklogsQuery();
    const firstItem = sharedTracklogsQuery.data && sharedTracklogsQuery.data[0];
    if (!firstItem) {
        return null;
    } else {
        return (
            <Navigate
                to={getSharedRouteString(firstItem?.shareUuid)}
            ></Navigate>
        );
    }
};

export default RedirectToShared;
